import { Reveal, RevealGroup, RevealItem } from "@/lib/motion";
import { Section, SectionHeading } from "./primitives";
import { ROADMAP } from "@/config/site";
import { Check } from "lucide-react";

export default function RoadmapSection() {
  return (
    <Section id="roadmap">
      <SectionHeading
        eyebrow="Roadmap"
        title="The Road Ahead"
        lead="A staged path from foundation to global expansion."
      />

      <RevealGroup className="relative mt-16 pl-8 sm:pl-10">
        {/* Vertical spine */}
        <div className="absolute left-[7px] top-2 h-full w-px bg-gradient-to-b from-indigo-500/50 via-white/10 to-transparent sm:left-[9px]" />

        <div className="flex flex-col gap-12">
          {ROADMAP.map((phase, i) => (
            <RevealItem key={phase.phase} className="relative" data-testid={`roadmap-${i}`}>
              {/* Node */}
              <span className="absolute -left-8 top-1.5 flex h-4 w-4 items-center justify-center sm:-left-10">
                <span className="absolute h-4 w-4 rounded-full border border-indigo-400/50 bg-[#030305]" />
                <span className="h-2 w-2 rounded-full bg-indigo-400" />
              </span>

              <div className="flex flex-col gap-1">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-indigo-400">
                  {phase.phase} — {phase.period}
                </span>
                <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-white sm:text-3xl">
                  {phase.title}
                </h3>
              </div>

              <div className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {phase.items.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3 rounded-xl border border-white/8 bg-white/[0.02] px-4 py-3"
                  >
                    <Check className="h-3.5 w-3.5 shrink-0 text-indigo-400" />
                    <span className="text-sm text-gray-300">{item}</span>
                  </div>
                ))}
              </div>
            </RevealItem>
          ))}
        </div>
      </RevealGroup>

      <Reveal className="mt-12 rounded-xl border border-white/8 bg-white/[0.02] px-5 py-4">
        <p className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.12em] text-gray-500">
          Roadmap milestones represent strategic objectives rather than guaranteed delivery dates.
        </p>
      </Reveal>
    </Section>
  );
}
